import { template as template_5676fdec932d42a4a22b37e84beabed0 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/icon';
export default RouteTemplate(template_5676fdec932d42a4a22b37e84beabed0(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
